import React from 'react';

type FilterBtnWhiteProps = {
    /**
     * The modifierClass can be used to attach events to the button
     */
    modifierClass?: string;
    buttonText?: string;
    isActive?: boolean;
    onClick?: () => void;
};

const FilterBtnWhite: React.FC<FilterBtnWhiteProps> = ({ modifierClass = '', buttonText = 'Filter Button', isActive = false, onClick }) => {
    return (
        <button className={`btn-filter-white ${modifierClass} ${isActive ? 'is-active' : ''}`} onClick={onClick}>
            {buttonText}
        </button>
    );
};

export default FilterBtnWhite;